var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container index"},[_c('Header',{attrs:{"active":0}}),_c('swiperBox'),_c('Achievement'),_c('Advantage'),_c('Software'),_c('Cartoon'),_c('Case'),_c('Partner',{attrs:{"title":'服务伙伴'}}),_c('Contact'),_c('Position'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }